import type { IntrusionPartitionRow, IntrusionZoneRow } from '../types';

type IntrusionZoneIdentity = Pick<IntrusionZoneRow, 'zoneId'>;
type IntrusionZonePartitions = readonly Pick<IntrusionPartitionRow, 'children'>[];

export const buildIntrusionZoneRowId = (partitionKey: string, zoneId: string): string =>
  `${partitionKey}:${zoneId}`;

export const getCanonicalIntrusionZoneId = (zone: IntrusionZoneIdentity): string =>
  zone.zoneId;

export const countUniqueIntrusionZones = (partitions: IntrusionZonePartitions): number =>
  new Set(
    partitions.flatMap((partition) => partition.children.map(getCanonicalIntrusionZoneId))
  ).size;
